export default __webpack_public_path__ + "static/media/T52.5a24f661.JPG";